define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi",
	"csi/def",
	"csi/def/Field",
	"csi/def/View",
	"csi/html",
	"csi/reflection",
	"csi/util"
], function(array,declare,csi,csiDef,Field,View,html,reflection,util) {

	return declare(View, {
		constructor: function(def) {
			this.m_fields = util.getDefs(def, 'Field', Field) || [];
		},

		resolve: function(/*Class*/rcRoot, /*Node*/nodeRoot, /*Boolean*/bConfigure) {
			// summary: disregard view node, as it may not be the node in context of form
			// FIX: we should probably try to make them the same though - I believe it has
			// to deal with the Form view not necessarily being defined on the node being acted upon
			nodeRoot = this.m_formData ? this.m_formData.getNode() : null;

			if (this.m_rcRoot) {
				rcRoot = this.m_rcRoot;
			} else if (nodeRoot) {
				rcRoot = reflection.getNodeClass(nodeRoot);
			}

			csiDef.resolveDefs(this.m_fields, this.getLocaleMap(rcRoot, bConfigure), rcRoot, nodeRoot);

			// compile list of headings from fields - do this so headings are resolved
			var	headings = this.m_headings = [];

			array.forEach(this.m_fields, function(f) {
				if (f.heading) {
					headings.push(f.heading);
				}
			});

			return this.inherited(arguments, [rcRoot, nodeRoot, bConfigure]);
		},

		getField: function(/*String*/controlName, /*String?*/path) {
			return csi.search(this.m_fields, function(f) {
				return (f.getControlName() == controlName) && (!path || (path == f.m_path));
			});
		},

		/**
		 * Get field by searching using unique control name
		 * @param {String} name 
		 * @param {String} path 
		 * @returns {Field}
		 */
		getFieldByUniqueName: function(name, path) {
			return this.m_fields.find((f) => f.getUniqueControlName() === name);
		},

		getFieldControl: function(/*String*/controlName) {
			var	f = this.getField(controlName);
			return f ? f.m_control : null;
		},

		getFieldValue: function(/*String*/controlName) {
			var	f = this.getField(controlName);
			return f ? f.getValue() : null;
		},

		addField: function(/*Field*/f, /*String?*/controlName, /*String?*/path) {
			// summary: add field, optionally before given control
			var	n = csi.locate(this.m_fields, function(f) {
				return (f.getControlName() == controlName) && (!path || (path == f.m_path));
			});

			if (n >= 0) {
				this.m_fields.splice(n, 0, f);
			} else {
				this.m_fields.push(f);
			}
			return f;
		},

		addFieldAfter: function(/*Field*/f, /*String?*/controlName, /*String?*/path) {
            // summary: add field, optionally after given control
            var n = csi.locate(this.m_fields, function(f) {
                return (f.getControlName() == controlName) && (!path || (path == f.m_path));
            });

            if (n >= 0) {
                this.m_fields.splice(n+1, 0, f);
            } else {
                this.m_fields.push(f);
            }
            return f;
        },

		removeField: function(/*String*/controlName) {
			// summary: remove first field with given control name
			this.removeFieldFromArray(this.m_fields,controlName);
		},

		removeFieldFromArray: function(/*String[]*/fields, /*String*/controlName) {
			// summary: remove first field with given control name
			fields.dele(function(f) { return (f.getControlName() == controlName); });
		}
	});
});